import { transformLives } from './utils'
import { cast, flow, types } from 'mobx-state-tree'
import { LiveModel, Live } from 'models/live'
import { ModelWithStatus, StatusType } from '../extensions'
import { doc, getDoc } from 'firebase/firestore'
import { db } from 'services'

export const LivesStoreModel = ModelWithStatus.named('LivesStore')
  .props({
    lives: types.array(LiveModel),
    fromRedirect: types.optional(types.boolean, true),
  })
  .views((self) => ({
    getLiveById(id: Live['id']) {
      return self.lives.find((live) => live.id === id)
    },
  }))
  .actions((self) => ({
    setLives(lives: Live[]) {
      self.lives = cast(lives)
    },
    setFromRedirect(fromRedirect: boolean) {
      self.fromRedirect = fromRedirect
    },
  }))
  .actions((self) => ({
    getLives: flow(function* () {
      self.setStatus(StatusType.PENDING)
      const docRef = doc(db, 'settings', 'redButton')

      yield getDoc(docRef)
        .then(async (docSnap) => {
          const data = docSnap.data()
          const lives = await transformLives(data?.lives)

          self.setLives(lives)
          self.setFromRedirect(data?.shouldRedirect)
          self.setStatus(StatusType.DONE)
        })
        .catch((error) => {
          console.error(error)
          self.setStatus(StatusType.ERROR)
        })
    }),
  }))
